import React from 'react';
import { theme } from '@xometry/xometry_loft';
import KebabMenu from '../../../../../components/KebabMenu';

export interface Props {
  handleEdit: any;
  handleArchivingTeam: any;
  canEdit: boolean;
  editMode: boolean;
}

const TeamManagementKebabMenu = (props: Props) => {
  const { handleEdit, handleArchivingTeam, canEdit, editMode } = props;
  const options = [];
  options.push({
    id: 1,
    optionText: 'Deactivate Team',
    textCssStyleString: `color: ${theme.colors.darkBlues[100]}; line-height: ${theme.lineHeights[2]}; font-size: ${theme.fontSizes[0]}`,
    iconName: 'fa-regular fa-alarm-snooze',
    iconCssStyleString: `color: ${theme.colors.darkBlues[75]}; margin-right: ${theme.space[2]}; padding-top: 2px`,
    itemCssStyleString: `margin-left: ${theme.space[3]}`,
    handleClick: () => handleArchivingTeam(),
  });

  if (canEdit && editMode) {
    options.push({
      id: 2,
      optionText: 'Edit Team Name',
      textCssStyleString: `color: ${theme.colors.darkBlues[100]}; line-height: ${theme.lineHeights[2]}; font-size: ${theme.fontSizes[0]}`,
      iconName: 'fa-regular fa-pen-to-square',
      iconCssStyleString: `color: ${theme.colors.darkBlues[75]}; margin-right: ${theme.space[2]}; padding-top: 2px`,
      itemCssStyleString: `margin-left: ${theme.space[3]}`,
      handleClick: () => handleEdit(),
    });
  }
  return (
    <KebabMenu
      width="150px"
      height="72px"
      tooltipText={`
    Open the menu to revise the team name or deactivate the team.
     You will still have access to all quotes and orders associated 
     with this team made by you and other team members.
    `}
      options={options}
    />
  );
};

export default TeamManagementKebabMenu;
